import React, { Component } from 'react';
import { Box, Button, WithStyles, withStyles } from '@material-ui/core';
import { EnviarMensajeStyles } from "../../styles";
import { Add,Send } from '@material-ui/icons';
import { firebaseAdmin } from '../../repository/Firestore.config';
import { guardarMensaje } from '../../repository/ChatDao';
import { IMensaje } from '../../interface/IMensaje';
import { readNotifiaciones } from '../../redux/ActionCreators';
import { actualizarMensaje,soporteAdicionalGuia } from '../../repository/ChatDao';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { INotificacion } from '../../interface/INotificacion';
import { IGuia } from '../../interface/IGuia';

type EnviarMensajeState = {mensaje:string}
interface EnviarMensajeProp extends WithStyles<typeof EnviarMensajeStyles> {
    mobile:boolean
    guia:IGuia
    children?: React.ReactNode;
    className?: string;
    notificaciones:INotificacion;
    mensajes:IMensaje[];
    leerNotificacion(guia:string,numeroNotifiaciones:number):any;
}
class EnviarMensajeComponent extends Component<EnviarMensajeProp, EnviarMensajeState> {

    constructor(props:EnviarMensajeProp){
        super(props);
        this.state = {
            mensaje:''
        }
        this.handleButtonEnviar = this.handleButtonEnviar.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.soporteAdicionalAutomatico = this.soporteAdicionalAutomatico.bind(this);
    }

    handleFocus(){
        if (this.props.notificaciones.numeroNotificaciones) {
            const mensajes = this.props.mensajes.filter((m) => (!m.Isseen?.Cliente))
            actualizarMensaje(this.props.guia.guia,mensajes)
            .then(() => {
                this.props.leerNotificacion(this.props.guia.guia,0)
            }).catch((err:any) => {
               console.log(err); 
            });
        }
    }

    handleInputChange(event:React.ChangeEvent<HTMLInputElement>){
        this.setState({
            mensaje: event.target['value']
        })
    }

    soporteAdicionalAutomatico(){
        const mensajeEntregaFallida = this.props.mensajes.filter((m) => m.Type==='CAUSAL_DETAIL')
        if (mensajeEntregaFallida.length) {
            this.props.guia.soporte_adicional=true;
            this.props.guia.soporte_entrega_fallida && soporteAdicionalGuia(this.props.guia.guia)
            this.props.guia.soporte_entrega_fallida=false;
        }
    }

    handleKeyPress(event:React.KeyboardEvent<HTMLInputElement>){
        if (event.keyCode===13) this.handleButtonEnviar()
        this.handleFocus();

    }

    handleButtonEnviar(){
        if (this.props.guia.estado==='FINALIZADO') return;
        this.soporteAdicionalAutomatico();
        const isseen = (this.props.guia.nombre_asesor || this.props.guia.soporte_adicional) ? {
            "Cliente":true,
            "Repartidor":false,
            "Asesor1":false
        } : {
            "Cliente":true,
            "Repartidor":false
        }
        const mensaje:IMensaje = {
            Remitente:'Cliente',
            Mensaje:this.state.mensaje,
            Guia:this.props.guia.guia,
            Type: 'TEXT',
            Codigo_Empleado:this.props.guia.codigo_empleado,
            Timestamp:firebaseAdmin.firestore.FieldValue.serverTimestamp(),
            Isseen:isseen,
            Nombre_Empleado:this.props.guia.nombre_destinatario
        }
        this.state.mensaje!=='' && guardarMensaje(mensaje,this.props.guia.guia);
        this.setState({
            mensaje : ''
        })
    }

    render(){
        const classes = this.props.classes
        const placeholder= this.props.guia.estado==='FINALIZADO' ? '' : '  Escribe un mensaje'
        return (
            <Box paddingTop="1px" paddingBottom="1px" color="#0E72BC" display="flex" justifyContent='space-between'>
                <Box style={{width:'100%', padding:'0px'}}  flexGrow={1}>
                   <input style={{width:'97%', paddingLeft:'10px'}}   id="input-mensaje" disabled={this.props.guia.estado==='FINALIZADO' ? true : false} onKeyDown={this.handleKeyPress} onFocus={() => this.handleFocus()} value={this.props.guia.estado==='FINALIZADO' ? '' : this.state.mensaje} onChange={this.handleInputChange} className={classes['input']} type="text" placeholder={placeholder} autoComplete='off'></input>
                </Box>
                <Box style={{ padding:'2px'}}>
                {
                    this.props.mobile 
                    ? <Send color="inherit" className={classes.sendmobile} fontSize="large" onClick={() => this.handleButtonEnviar()} />
                    : <Button style={{  minHeight: '40px'}} disabled={this.props.guia.estado==='FINALIZADO' ? true : false} id="btn-mensaje"  variant="contained" className={classes['button']} size="medium" onClick={() => this.handleButtonEnviar()}>
                        Enviar
                    </Button>   
                }
                </Box>
                
            </Box>
        )   
    }
}

const mapStateToProps = (state:any) => {
    return {
      mensajes: state.mensajesReducer,
      notificaciones: state.notifiacionReducer
    }
  }

const mapDispatchToProps = (dispatch: Dispatch) => ({
    leerNotificacion(guia:string,numeroNotifiaciones:number){
        dispatch(readNotifiaciones(guia,numeroNotifiaciones))
    }
})

export const EnviarMensaje = withStyles(EnviarMensajeStyles)(connect(mapStateToProps,mapDispatchToProps)(EnviarMensajeComponent))